import { LanguageCode } from "@shared/view-models/language.viewmodel";

export const HELP_LINK = {
    [LanguageCode.PL]: 'https://confluence.tekom.pl/display/TES',
    [LanguageCode.EN]: 'https://support.tekom.pl/portal/en-gb/home',
    [LanguageCode.PT]: 'https://support.tekom.pl/portal/pt/home',
};
